export default __webpack_public_path__ + "images/9D.35d4cb2.png";